import {
  HwProceedButton,
  IStyles,
  IconWrapper,
  ImageWrapper,
  Loader,
  PrimaryButton,
  deserify,
  getDeviceType,
  getLocalStorage,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
  calculateTotalTime,
} from '@geneo2-web/shared-ui';
import { Box, Typography, useMediaQuery } from '@mui/material';
import {
  BloomLevelEnum,
  Module_ModuleCategoryEnum,
  Question,
} from '@protos/content_management/content.db_pb';
import {
  AssessmentEnum,
  MarkingSchemeEnum,
  ModeOfConductionEnum,
  TaskCreationStatusEnum,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';

import {
  calculateMinMaxTime,
  totalNoQuestions,
} from '../../../../utils/functions';
import { interactionEvent } from '../../../Auth/auth.events';
import { setToastInfo } from '../../../Home/reducer/homeDashboard.slice';
import {
  resetAssessmentFlowState,
  resetSelectedTasksInfo,
  setFAAssessmentConfig,
  setFAEditStep,
  setModuleFilteredQuestions,
  setSelectedTasksInfo,
  setSubmittedAssessmentId,
} from '../../reducer/assessmentFlow.slice';
import DifficultyNos from './components/DifficultyNos';
import QuestionsList from './components/QuestionsList';
import ReviewHeader from './components/ReviewHeader';
import {
  canEdit,
  createTaskInfoModel,
  createTaskInfoModel_2,
  getAssessmentTypeName,
  updateApiResponse,
} from './functions';
import {
  ASSESSMENT_ASSIGN,
  ASSESSMENT_CREATE,
  DIAGNOSTIC,
  FORMATIVE,
  HOME,
  HOMEWORK,
} from '../../../../routeHandling/RoutesNomenclature';
import SelectedChapters from '../../components/SelectedChapters';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import { ChapterTopicPopup } from '../../../../components/ChapterTopicPopup';
import { EditWarningPopup } from '../../../../components/EditWarningPopup';
import {
  AssessmentCreationEnum,
  TaskInfoModel,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { BloomConductionQuestionDetails } from './components/BloomConductionQuestionDetails';
import { QuestionCountAndMarks } from './components/QuestionCountAndMarks';

const styles: IStyles = {
  root: {
    backgroundColor: 'neutral.paleGrey',
    // height: '100vh',
    marginBottom: pxTovW(10),
    maxHeight: {
      xs: `calc(100vh - ${pxToRem(60)})`,
      md: `calc(100vh - ${pxTovW(100)})`,
    },
    display: 'flex',
    flexDirection: 'column',
    overflow: { md: 'hidden', xs: 'auto' },
  },
  mainContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { md: pxTovW(40) },
    padding: { md: pxToRem(20), lg: `${pxTovW(15)} ${pxTovW(240)}` },
    overflow: 'scroll',
    height: '100%',
  },
  leftPanel: {
    flexBasis: { md: pxTovW(550), lg: pxTovW(400) },
    display: 'flex',
    flexDirection: 'column',
    gap: { md: pxTovW(30) },
  },
  rightPanel: {
    flexBasis: { lg: pxTovW(1000) },
    paddingBottom: { xs: pxToRem(70), md: 0 },
    overflow: { xs: 'initial', md: 'scroll' },
  },
  mobileContainer: {
    display: { xs: 'flex', md: 'none' },
    border: '1px solid #007CDC4D',
    flexDirection: 'row',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
    padding: { xs: pxToRem(10), md: pxTovW(15) },
    marginY: { xs: pxToRem(10), md: pxTovW(10) },
    marginX: { xs: pxToRem(20) },
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    justifyContent: 'space-between',
  },
};
interface IProps {
  setQuestionBankDisplayFlag: Dispatch<SetStateAction<boolean>>;
}
export default function ReviewAssessment(props: IProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const assessmentName = getAssessmentTypeName(pathname);
  const isDiagnosticAssessment = (): boolean => assessmentName === 'DIAGNOSTIC';
  const isFormativeAssessment = (): boolean => assessmentName === 'FORMATIVE';
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [logoClick, setLogoClick] = useState(false);
  const { setQuestionBankDisplayFlag } = props;
  const navigate = useNavigate();
  const android = window.Android;
  const deviceType = getDeviceType();
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();
  const dispatch = useAppDispatch();
  const { module_id } = useParams();
  const teacher_id = getLocalStorage('userId');
  const { isOffline } = useDownloadContext();
  const [quesLoading, setQuesLoading] = useState(false);
  const [quesError, setQuesError] = useState(false);
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const [selectedopen, setSelectedOpen] = useState(false);
  const [editclick, setEditClick] = useState(false);
  const [bloomOpen, setBloomOpen] = useState(false);
  const {
    LmsAssessmentTeacherAPIServiceV7WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const {
    questions_count,
    module_filtered_questions,
    selected_tasks_info,
    fetched_assessment_details,
    fa_selected_chapter_data,
    fa_assessment_config,
    assesment_creation_type,
    fa_edit_step,
    fa_question_module_map,
  } = deserify(useAppSelector((state) => state.assessment));
  const { manage_mode_of_conduction } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const questionModuleMap = fa_question_module_map || [];
  const handleInputFocus = async () => {
    // navigate(`${HOMEWORK_QUESTIONBANK}/${module_id}`);
    setQuestionBankDisplayFlag(true);
    await interactionEvent({
      url: `Teacher_current_${assessmentName.toLowerCase()}`,
      context: 'My_assessment',
      name: 'SEARCH',
      isOffline: isOffline,
    });
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const home = searchParams.get('home');
  const handleback = () => {
    if (fa_assessment_config) {
      dispatch(setFAEditStep('settings'));
      setEditPopupOpen(true);
      setEditClick(false);
      return;
    }
    console.log('selected function');
    dispatch(resetSelectedTasksInfo());
    // navigate(`${HOMEWORK_CREATE}/${module_id}`);
    navigate(-1);
  };
  const isClickerConductionMode = () => {
    const modeOfConduction =
      assesment_creation_type?.creationType === 'Readymade'
        ? manage_mode_of_conduction
        : assesment_creation_type?.modeOfConduction;
    return (
      modeOfConduction === ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
    );
  };
  const handleLogoClick = () => {
    if (
      assesment_creation_type?.asessmentType ===
        AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
      assesment_creation_type.creationType === 'Create'
    ) {
      setLogoClick(true);
      setEditPopupOpen(true);
      setEditClick(false);
      return;
    }
    dispatch(resetAssessmentFlowState());
    navigate(HOME);
  };
  useEffect(() => {
    setSelectedFunction(() => handleback);
    setSelectedLogoClickHandler(() => handleLogoClick);
    return () => {
      setSelectedFunction(null);
      setSelectedLogoClickHandler(null);
    };
  }, []);

  useEffect(() => {
    try {
      if (deviceType === 'android' && android?.disableAppRefresh) {
        android.disableAppRefresh();
        console.log('App refresh enabled on Android for home page');
      }
    } catch (error) {
      console.log(
        'An error occurred while attempting to enable app refresh on Android:'
      );
    }
  }, []);

  const getModuleQuestions = async (moduleId: string) => {
    try {
      setQuesLoading(true);
      const response =
        await LmsAssessmentTeacherAPIServiceV7WithStatusCodeHandler.getModuleQuestionsWithFilters(
          {
            teacherId: teacher_id,
            subjectId: class_subject_info?.subjectId,
            modeOfConduction: isClickerConductionMode()
              ? ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
              : ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP,
            assessmentCreationType:
              isFormativeAssessment() || isDiagnosticAssessment()
                ? AssessmentCreationEnum.ASSESSMENT_CREATION_FORMATIVE
                : AssessmentCreationEnum.ASSESSMENT_CREATION_HOMEWORK,
            moduleIds: [Number(moduleId)],
            requiredDifficultyLevelsCountInfo: questions_count,
          }
        );
      if (response.data) {
        const data = response.data;
        if (module_filtered_questions) {
          const updatedResponse = updateApiResponse(
            data,
            module_filtered_questions,
            questions_count
          );
          dispatch(
            setModuleFilteredQuestions({ questions: updatedResponse.questions })
          );
          const tasksInfo = createTaskInfoModel_2(
            updatedResponse.questions,
            selected_tasks_info
          );
          dispatch(setSelectedTasksInfo(tasksInfo));
        } else {
          dispatch(setModuleFilteredQuestions(data));
        }
      }
      setQuesLoading(false);
    } catch (err) {
      console.log(err);
      setQuesLoading(false);
      setQuesError(true);
      console.error(err);
    }
  };
  // const handlingQuestionsOrder = () => {};

  const updateClickHandler = async () => {
    if (module_id) {
      getModuleQuestions(module_id);
    }

    await interactionEvent({
      url: `Teacher_current_${assessmentName.toLowerCase()}`,
      context: 'My_assessment',
      name: 'UPDATE',
      isOffline: isOffline,
    });
  };

  const proceedClickhandler = async () => {
    await interactionEvent({
      url: `Teacher_current_${assessmentName.toLowerCase()}`,
      context: 'My_assessment',
      name: 'PROCEED',
      isOffline: isOffline,
    });
    if (fa_assessment_config) {
      if (fa_assessment_config.noOfQuestions === 0) {
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'No questions available',
            open: true,
          })
        );
      } else {
        submitHomework(TaskCreationStatusEnum.TASK_CREATION_STATUS_APPROVED);
      }
    } else {
      if (
        questions_count.noOfHighQuestions === 0 &&
        questions_count.noOfMediumQuestions === 0 &&
        questions_count.noOfLowQuestions === 0
      ) {
        dispatch(
          setToastInfo({
            variant: 'error',
            label: 'Add atleast one question ',
            open: true,
          })
        );
      } else {
        const highQuestionCount = module_filtered_questions?.questions.filter(
          (ques) => ques.questionMeta?.difficultyLevel === 1
        ).length;
        const mediumQuestionCount = module_filtered_questions?.questions.filter(
          (ques) => ques.questionMeta?.difficultyLevel === 2
        ).length;
        const lowQuestionCount = module_filtered_questions?.questions.filter(
          (ques) => ques.questionMeta?.difficultyLevel === 3
        ).length;
        if (
          highQuestionCount === questions_count.noOfHighQuestions &&
          mediumQuestionCount === questions_count.noOfMediumQuestions &&
          lowQuestionCount === questions_count.noOfLowQuestions
        ) {
          submitHomework(TaskCreationStatusEnum.TASK_CREATION_STATUS_APPROVED);
        } else {
          dispatch(
            setToastInfo({
              variant: 'error',
              label:
                'Please click update and review questions before proceeding ',
              open: true,
            })
          );
        }
      }
    }
    try {
      if (deviceType === 'android' && android?.enableAppRefresh) {
        console.log('enableAppRefresh called');
        android.enableAppRefresh();
      }
    } catch (error) {
      console.log(
        'An error occurred while attempting to enable app refresh on Android:'
      );
    }
  };

  const submitHomework = async (status: TaskCreationStatusEnum) => {
    // repeated TaskInfoModel selected_tasks_info = 7 [(google.api.field_behavior) = REQUIRED];
    const moduleIds = Number(module_id);

    try {
      setIsLoading(true);
      const resposne =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            teacherId: teacher_id,
            subjectId: class_subject_info?.subjectId,
            sectionId: class_subject_info?.sectionId,

            taskName: 'new Assessment',
            modeOfConduction:
              assesment_creation_type?.creationType === 'Readymade'
                ? manage_mode_of_conduction
                : assesment_creation_type.modeOfConduction,
            moduleId:
              !isFormativeAssessment() && !isDiagnosticAssessment()
                ? moduleIds
                : undefined, // do we  have to provide all the module ids
            category:
              !isFormativeAssessment() && !isDiagnosticAssessment()
                ? Module_ModuleCategoryEnum.MODULE_CATEGORY_TOPIC
                : Module_ModuleCategoryEnum.MODULE_CATEGORY_BOOK,
            selectedTasksInfo: selected_tasks_info,
            creationStatus: status,
            sourceGeneoAssessmentId: fetched_assessment_details?.teacherId
              ? undefined
              : fetched_assessment_details?.assessmentId,
            questionModuleMap: isFormativeAssessment()
              ? questionModuleMap
              : undefined,
            taskType:
              assessmentName === 'DIAGNOSTIC'
                ? TaskEnum.TASK_DIAGNOSTIC_ASSESSMENT_CUSTOM
                : assessmentName === 'FORMATIVE'
                ? TaskEnum.TASK_FORMATIVE_ASSESSMENT_CUSTOM
                : TaskEnum.TASK_HOMEWORK_CUSTOM,

            chapterIdsInfo: isFormativeAssessment()
              ? fetched_assessment_details
                ? fetched_assessment_details?.taskMetaInfo?.chapterInfo
                    ?.chapterTopicsInfo
                : module_filtered_questions?.taskMetaInfo?.chapterInfo
                    ?.chapterTopicsInfo
              : undefined,
            markingSchemeType:
              assesment_creation_type.markingScheme ??
              MarkingSchemeEnum.MARKING_SCHEME_GENEO,
          }
        );
      if (resposne.data) {
        const hwId = resposne.data.assessment?.assessmentId;
        dispatch(setSubmittedAssessmentId(hwId));
        assessmentName === 'DIAGNOSTIC'
          ? navigate(`${DIAGNOSTIC}${ASSESSMENT_ASSIGN}`)
          : assessmentName === 'FORMATIVE'
          ? navigate(`${FORMATIVE}${ASSESSMENT_ASSIGN}`)
          : navigate(`${HOMEWORK}${ASSESSMENT_ASSIGN}`);
      }
    } catch (err) {
      console.log(err);
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  const totalMarks = (question?: Question[]) => {
    if (!question) {
      return 0;
    }
    const marks = question.reduce(
      (acc, curr) =>
        acc +
        (curr.question?.model.value?.commonQuestionContent?.marks[0] || 0),
      0
    );
    return marks;
  };

  function totalMarks_2(
    questions: Question[] = [],
    task_info_array?: TaskInfoModel[]
  ): number {
    if (!task_info_array) {
      // fallback: sum marks from questions directly
      return questions.reduce(
        (acc, curr) =>
          acc +
          (curr.question?.model?.value?.commonQuestionContent?.marks[0] || 0),
        0
      );
    }

    // map task_info_array by sequence
    const sortedTasks = [...task_info_array].sort(
      (a, b) => a.sequence - b.sequence
    );

    let total = 0;

    for (const task of sortedTasks) {
      const q = questions.find((q) => q.questionId === task.questionId);
      if (q?.question?.model?.value?.commonQuestionContent) {
        // assign marks from task_info_array
        const marks = Number(task.maxMarks ?? 1);
        total += marks;
      }
    }

    return total;
  }

  const timeOfQuestions = () => {
    if (module_filtered_questions?.questions?.length) {
      return calculateTotalTime(module_filtered_questions.questions).toString();
    }
    return `${calculateMinMaxTime(questions_count).min}-${
      calculateMinMaxTime(questions_count).max
    }`;
  };

  const getBloomLevelData = () => {
    if (!module_filtered_questions || !module_filtered_questions.questions) {
      return [];
    }

    const bloomLevelMapping = [
      {
        title: 'Retention',
        color: '#005DAA',
        type: BloomLevelEnum.BLOOMLEVEL_RETENTION,
      },
      {
        title: 'Analysis',
        color: '#F1A33B',
        type: BloomLevelEnum.BLOOMLEVEL_ANALYSIS,
      },
      {
        title: 'Application',
        color: '#009383',
        type: BloomLevelEnum.BLOOMLEVEL_APPLICATION,
      },
      {
        title: 'Comprehension',
        color: '#5DC152',
        type: BloomLevelEnum.BLOOMLEVEL_COMPREHENSION,
      },
      {
        title: 'Creation',
        color: '#00bfc8',
        type: BloomLevelEnum.BLOOMLEVEL_CREATION,
      },
      {
        title: 'Evaluation',
        color: '#e80000',
        type: BloomLevelEnum.BLOOMLEVEL_EVALUATION,
      },
    ];

    const bloomLevelData = bloomLevelMapping.map(({ title, color, type }) => {
      const filteredQuestions = module_filtered_questions.questions.filter(
        (question) => question.questionMeta?.bloomLevel === type
      );
      return {
        title,
        Questions: filteredQuestions.length
          ? (filteredQuestions.length /
              module_filtered_questions.questions.length) *
            100
          : 0,
        color,
      };
    });

    return bloomLevelData;
  };

  // --------------------------------------------------------------

  if (isLoading) return <Loader />;

  return (
    <Box sx={styles.root}>
      <ReviewHeader
        heading={
          isFormativeAssessment() ? 'Formative Assessment' : 'My Assessment'
        }
        disabled={
          fa_assessment_config?.noOfQuestions === 0 ||
          totalNoQuestions(questions_count) === 0
        }
        proceedClickhandler={proceedClickhandler}
      />

      <Box sx={styles.mainContainer}>
        <Box sx={styles.leftPanel}>
          <Box
            sx={{
              padding: { xs: pxToRem(20), md: 0 },
              display:
                canEdit(teacher_id, fetched_assessment_details) === true &&
                !isDiagnosticAssessment() &&
                !(
                  assesment_creation_type?.asessmentType ===
                    AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT && // to make readymade FAs uneditable
                  assesment_creation_type.creationType === 'Readymade'
                )
                  ? 'block'
                  : 'none',
            }}
          >
            <Box
              sx={{
                width: { xs: '100%', md: '100%' },
                display: 'flex',
                gap: { xs: pxToRem(5), md: pxTovW(13) },
                background: '#D2EBFF',
                borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
                cursor: 'pointer',
              }}
              onClick={handleInputFocus}
            >
              <ImageWrapper
                name="questionBank"
                type="png"
                parentFolder="icons"
                styles={{
                  width: { xs: pxToRem(65), md: pxTovW(110), lg: pxTovW(81) },
                  height: 'auto',
                  marginY: 'auto',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginY: 'auto',
                  gap: { xs: pxToRem(4), md: pxTovW(5) },
                }}
              >
                <Box
                  sx={{
                    width: 'max-content',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#1674BF',
                    padding: {
                      xs: `${pxToRem(3)} ${pxToRem(12)} ${pxToRem(4)}`,
                      md: `${pxTovW(5)} ${pxTovW(15)} ${pxTovW(6)}`,
                    },
                    borderRadius: {
                      xs: pxToRem(10),
                      md: pxTovW(20),
                      lg: pxTovW(17),
                    },
                  }}
                >
                  <Typography
                    variant="smallText"
                    color={'common.white'}
                    fontWeight={'600'}
                  >
                    1000+ Questions
                  </Typography>
                </Box>
                <Typography
                  variant={isMobile ? 'h3' : isIpad ? 'h5' : 'h4'}
                  fontWeight={'600'}
                  fontFamily={'poppins'}
                >
                  Add from Question Bank
                </Typography>
              </Box>
              <Box
                sx={{
                  marginLeft: 'auto',
                  marginY: 'auto',
                  marginRight: { xs: pxToRem(15), md: pxTovW(20) },
                }}
              >
                <ImageWrapper
                  styles={{
                    width: { xs: pxToRem(23), md: pxTovW(30) },
                    height: { xs: pxToRem(24), md: pxTovW(30) },
                  }}
                  name="right-arrow-circle"
                  type="png"
                  parentFolder="illustrations"
                />
              </Box>
            </Box>
          </Box>

          <Box>
            {!isFormativeAssessment() && (
              <DifficultyNos // will need to romove this for FA Creation flow
                mobileVariant="horizontal"
                desktopVariant="vertical"
                disabled={
                  isDiagnosticAssessment() ||
                  !canEdit(teacher_id, fetched_assessment_details)
                }
              />
            )}

            {/* //! Selected Chapters */}
            {isFormativeAssessment() || isDiagnosticAssessment() ? ( // wont need to change this as it should work if we provide assessment info from getModuleQuestionsWithFilters
              <Box
                sx={{
                  width: '100%',
                  display: { xs: 'none', md: 'flex' },
                }}
              >
                <SelectedChapters
                  editClickHandler={() => {
                    dispatch(setFAEditStep('chapterSelection'));
                    setEditPopupOpen(true);
                    setEditClick(true);
                  }}
                  questionModuleMap={questionModuleMap}
                  assessmentTaskInfo={
                    assesment_creation_type?.creationType === 'Create' &&
                    assesment_creation_type?.asessmentType ===
                      AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
                    fa_selected_chapter_data // this was added to check if the user is coming from fa creation flow, can be removed later as it does not accouncts for all the diffrent types of assessment, which is done by assessment creation type, currently it is only used for formative assessments
                      ? module_filtered_questions?.taskMetaInfo
                      : fetched_assessment_details?.taskMetaInfo
                  }
                />
              </Box>
            ) : (
              <></>
            )}

            {!isDiagnosticAssessment() &&
              !isFormativeAssessment() &&
              canEdit(teacher_id, fetched_assessment_details) && (
                <Box
                  sx={{
                    display: {
                      xs: 'block',
                      md: 'none',
                      width: '60%',
                      margin: 'auto',
                      marginTop: pxToRem(10),
                      marginBottom: pxToRem(10),
                    },
                  }}
                >
                  <PrimaryButton
                    onClick={updateClickHandler}
                    // disabled={
                    //   questions_count.noOfHighQuestions === 0 &&
                    //   questions_count.noOfLowQuestions === 0 &&
                    //   questions_count.noOfMediumQuestions === 0
                    // }
                  >
                    Update
                  </PrimaryButton>
                </Box>
              )}
          </Box>

          {!isMobile ? (
            <>
              <BloomConductionQuestionDetails
                timeOfQuestions={timeOfQuestions}
                getBloomLevelData={getBloomLevelData}
                setEditPopupOpen={setEditPopupOpen}
                setEditClick={setEditClick}
                isFormativeAssessment={isFormativeAssessment}
                rootStyles={
                  {
                    // marginBottom: { xs: pxToRem(0), md: pxTovW(40) },
                  }
                }
                modeOfConduction={
                  isClickerConductionMode()
                    ? ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
                    : ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP
                }
              />
              <QuestionCountAndMarks
                questionCount={totalNoQuestions(questions_count)}
                totalMarks={totalMarks_2(
                  module_filtered_questions?.questions,
                  selected_tasks_info
                )}
              />
            </>
          ) : null}

          {isFormativeAssessment() ? (
            <Box sx={styles.mobileContainer}>
              <Typography
                variant={isMobile ? 'h2' : 'h3'}
                sx={{
                  fontWeight: 'bold',
                }}
              >
                What's Covered
              </Typography>
              <Box
                sx={{
                  display: { xs: 'flex', md: 'none' },
                  gap: { xs: pxToRem(10) },
                }}
              >
                <IconWrapper
                  name="view"
                  type="png"
                  parentFolder="icons"
                  size="md"
                  customSx={{
                    height: { xs: pxToRem(20) },
                    width: { xs: pxToRem(20) },
                  }}
                  onClick={() => setSelectedOpen(true)}
                />
                {fa_selected_chapter_data && (
                  <IconWrapper
                    name="edit"
                    type="png"
                    parentFolder="icons"
                    size="large"
                    customSx={{
                      height: { xs: pxToRem(23) },
                      width: { xs: pxToRem(23) },
                    }}
                    onClick={() => {
                      dispatch(setFAEditStep('chapterSelection'));
                      setEditPopupOpen(true);
                      setEditClick(true);
                    }}
                  />
                )}
              </Box>
            </Box>
          ) : (
            <></>
          )}

          <Box sx={styles.mobileContainer}>
            <Typography
              variant={isMobile ? 'h2' : 'h3'}
              sx={{
                fontWeight: 'bold',
              }}
            >
              {assesment_creation_type.markingScheme !==
              MarkingSchemeEnum.MARKING_SCHEME_JEE
                ? 'Bloom Level'
                : 'More Info'}
            </Typography>
            <Box
              sx={{
                display: { xs: 'flex', md: 'none' },
                gap: { xs: pxToRem(10) },
              }}
            >
              <IconWrapper
                name="view"
                type="png"
                parentFolder="icons"
                size="large"
                customSx={{
                  height: { xs: pxToRem(20) },
                  width: { xs: pxToRem(20) },
                }}
                onClick={() => {
                  setBloomOpen(true);
                }}
              />
              {isFormativeAssessment() && fa_selected_chapter_data ? (
                <IconWrapper
                  name="edit"
                  type="png"
                  parentFolder="icons"
                  size="md"
                  customSx={{
                    height: { xs: pxToRem(23) },
                    width: { xs: pxToRem(23) },
                  }}
                  onClick={() => {
                    dispatch(setFAEditStep('settings'));
                    setEditPopupOpen(true);
                    setEditClick(true);
                  }}
                />
              ) : (
                <></>
              )}
            </Box>
          </Box>

          {!isDiagnosticAssessment() &&
            !isFormativeAssessment() &&
            canEdit(teacher_id, fetched_assessment_details) && (
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <PrimaryButton
                  onClick={updateClickHandler}
                  // disabled={
                  //   questions_count.noOfHighQuestions === 0 &&
                  //   questions_count.noOfLowQuestions === 0 &&
                  //   questions_count.noOfMediumQuestions === 0
                  // }
                >
                  Update
                </PrimaryButton>
              </Box>
            )}
        </Box>

        <Box sx={styles.rightPanel}>
          <QuestionsList
            isFormative={isFormativeAssessment()}
            isDiagnostic={isDiagnosticAssessment()}
            title={<Typography variant="h2">Review Questions</Typography>}
            subtitle={
              canEdit(teacher_id, fetched_assessment_details) === true &&
              !isDiagnosticAssessment() &&
              !(
                assesment_creation_type?.asessmentType ===
                  AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT && // to make readymade FAs uneditable
                assesment_creation_type.creationType === 'Readymade'
              )
                ? 'Replace, Re-order, or Remove'
                : ''
            }
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'fixed',
          bottom: 10,
          left: 12,
        }}
      >
        <HwProceedButton
          clickHandler={proceedClickhandler}
          disabled={totalNoQuestions(questions_count) === 0}
          tabs={[
            { quantity: `${totalNoQuestions(questions_count)}`, title: 'Qs' },
            {
              quantity: timeOfQuestions(),
              title: 'Mins',
            },
            {
              quantity: `${totalMarks_2(
                module_filtered_questions?.questions,
                selected_tasks_info
              )}`,
              title: 'Marks',
            },
          ]}
        />
      </Box>

      <ChapterTopicPopup
        open={selectedopen}
        handleClose={() => {
          setSelectedOpen(false);
        }}
        popupBody={
          <SelectedChapters
            editClickHandler={() => {
              dispatch(setFAEditStep('chapterSelection'));
              setEditPopupOpen(true);
              setEditClick(true);
            }}
            questionModuleMap={questionModuleMap}
            assessmentTaskInfo={
              assesment_creation_type?.creationType === 'Create' &&
              assesment_creation_type?.asessmentType ===
                AssessmentEnum.ASSESSMENT_FORMATIVE_ASSESSMENT &&
              fa_selected_chapter_data // this was added to check if the user is coming from fa creation flow, can be removed later as it does not accouncts for all the diffrent types of assessment, which is done by assessment creation type
                ? module_filtered_questions?.taskMetaInfo
                : fetched_assessment_details?.taskMetaInfo
            }
          />
        }
      />

      <ChapterTopicPopup
        open={bloomOpen}
        handleClose={() => {
          setBloomOpen(false);
        }}
        mainContainerSx={{
          paddingX: { xs: pxToRem(10), md: pxTovW(15) },
          paddingY: { xs: pxToRem(25), md: pxTovW(15) },
        }}
        popupBody={
          <BloomConductionQuestionDetails
            timeOfQuestions={timeOfQuestions}
            getBloomLevelData={getBloomLevelData}
            setEditPopupOpen={setEditPopupOpen}
            setEditClick={setEditClick}
            isFormativeAssessment={isFormativeAssessment}
            modeOfConduction={
              isClickerConductionMode()
                ? ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
                : ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_APP
            }
          />
        }
      />

      <EditWarningPopup
        open={editPopupOpen}
        handleClose={() => {
          if (logoClick) {
            setLogoClick(false);
            setSelectedLogoClickHandler(() => handleLogoClick);
          } else {
            setSelectedFunction(() => handleback);
          }
          setEditPopupOpen(false);
          setEditClick(false);
          dispatch(setFAEditStep(undefined));
        }}
        yesClickHandler={() => {
          if (logoClick) {
            dispatch(resetAssessmentFlowState());
            navigate(HOME);
            return;
          }
          if (fa_edit_step === 'chapterSelection') {
            dispatch(setFAAssessmentConfig(undefined));
          }
          if (home) {
            navigate(
              `${FORMATIVE}${ASSESSMENT_CREATE}/${class_subject_info?.subjectId}?home=true`
            );
          } else {
            navigate(
              `${FORMATIVE}${ASSESSMENT_CREATE}/${class_subject_info?.subjectId}`
            );
          }
          setEditPopupOpen(false);
        }}
        noClickHandler={() => {
          if (logoClick) {
            setLogoClick(false);
            setSelectedLogoClickHandler(() => handleLogoClick);
          } else {
            setSelectedFunction(() => handleback);
          }
          dispatch(setFAEditStep(undefined));
          setEditPopupOpen(false);
        }}
        iconname={editclick ? 'edit3' : 'back'}
        text1={
          editclick
            ? 'If you want to edit, your changes may be lost.'
            : 'If you go back, you may lose your changes.'
        }
        text2={
          editclick
            ? 'Are you sure you want to continue?'
            : 'Are you sure you want go back?'
        }
      />
    </Box>
  );
}
